import { Field, ImageField, LinkField } from '@sitecore-content-sdk/nextjs';

const ContentGridQuery = /** GQL */ `query($datasource: String!, $language: String!){
    root: item(path: $datasource, language: $language) {
    children(first:500) {      
        results {
          ... on ContentOverride {
            overrideContent {
              jsonValue
            }
            title {
              jsonValue
            }
            removeTitleLink {
              jsonValue
            }
            image {
              jsonValue
            }
            tag {
              jsonValue
            }
            description {
              jsonValue
            }
            url: field(name: "Url") {
              jsonValue
            }
            ctaText {
              jsonValue
            }
          }
        }
      }
    }
  }
  
`;

export default ContentGridQuery;

export type ContentGridQueryResult = {
  root?: {
    children?: {
      results?: ContentOverride[];
    };
  };
};

export type ContentOverride = {
  overrideContent?: {
    jsonValue: Field<string>;
  };
  title?: {
    jsonValue: Field<string>;
  };
  removeTitleLink?: {
    jsonValue: Field<boolean>;
  };
  image?: {
    jsonValue: ImageField;
  };
  tag?: {
    jsonValue: Field<string>;
  };
  description?: {
    jsonValue: Field<string>;
  };
  url?: {
    jsonValue: LinkField;
  };
  ctaText?: {
    jsonValue: Field<string>;
  };
};
